module.exports = __webpack_public_path__ + "media/images/banner2-3903dcbd2391453ec86d629a13fda55f.jpg";